__turbopack_context__.v({
  "image_block": "lC4THW_image_block",
  "image_block--large": "lC4THW_image_block--large",
  "image_block--variant-attention": "lC4THW_image_block--variant-attention",
  "image_block--variant-do": "lC4THW_image_block--variant-do",
  "image_block--variant-dont": "lC4THW_image_block--variant-dont",
  "image_block__diagonal": "lC4THW_image_block__diagonal",
  "image_block__figure": "lC4THW_image_block__figure",
  "image_block__footer": "lC4THW_image_block__footer",
  "image_block__image": "lC4THW_image_block__image",
  "image_block__image--bottom_padding": "lC4THW_image_block__image--bottom_padding",
  "image_block__image--top_padding": "lC4THW_image_block__image--top_padding",
  "image_block__image_wrapper": "lC4THW_image_block__image_wrapper",
  "image_block__image_wrapper--bottom_padding": "lC4THW_image_block__image_wrapper--bottom_padding",
  "image_block__image_wrapper--top_padding": "lC4THW_image_block__image_wrapper--top_padding",
});
